import React, { useState, useEffect, useRef } from "react";
import "../assets/Css/PopupOverlay.css";
import shopifyFree from ".././assets/images/home2.jpg";
import homeXebrand from ".././assets/images/home.jpg";

export default function PopupOverlay() {
  const [showPopup, setShowPopup] = useState(false);
  const popupRef = useRef(null); // Reference for the popup content

  useEffect(() => {
    // Show the popup when the page loads
    setShowPopup(true);

    // Close popup when clicking outside
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    };

    // Add event listener to detect clicks outside the popup
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClose = () => {
    setShowPopup(false); // Close the popup
  };

  const handleRedirect = (url) => {
    window.open(url, "https://prebuilttemplates.com/"); // Open the URL in a new tab
  };

  return (
    <>
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content-contianer-wrap">
            <div className="popup-content" ref={popupRef}>
              <div className="title-contiaer">
                <button className="back-to-posts" onClick={handleClose}>
                  <svg
                    fill="#000000"
                    viewBox="0 0 56 56"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M 11.9805 36.2149 C 11.9805 37.4570 12.9414 38.3711 14.0664 38.3711 C 15.1914 38.3711 16.1289 37.3867 16.1289 36.3086 L 16.1289 28.8320 L 15.7071 18.1680 L 19.4571 22.4102 L 40.4102 43.3867 C 40.8555 43.8086 41.3476 44.0195 41.8633 44.0195 C 43.0117 44.0195 44.0195 42.9648 44.0195 41.8633 C 44.0195 41.3711 43.7852 40.8555 43.3633 40.4336 L 22.4102 19.4570 L 18.1680 15.7070 L 29.3242 16.1289 L 36.3086 16.1289 C 37.3867 16.1289 38.3476 15.1914 38.3476 14.0898 C 38.3476 12.9883 37.5039 12.0273 36.2149 12.0273 L 14.2071 11.9805 C 12.8242 11.9805 11.9805 12.8711 11.9805 14.2070 Z"></path>
                  </svg>
                </button>
                <h2>Shopify Pre-built section</h2>
                <p>Please Visit.</p>
              </div>
              <div className="popup-continer-wrap">
                {/* Shopify Free Section Option */}
                <div
                  className="popup-container-cont"
                  onClick={() =>
                    handleRedirect("https://prebuilttemplates.com/sections/")
                  } // Redirects to new tab
                >
                  <div className="popup-cont">
                    <svg
                      viewBox="-18 0 292 292"
                      xmlns="http://www.w3.org/2000/svg"
                      preserveAspectRatio="xMidYMid"
                      fill="#000000"
                    >
                      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-1.703-1.703-5.029-1.185-6.32-.805-.19.056-3.388 1.043-8.678 2.68-5.18-14.906-14.322-28.604-30.405-28.604-.444 0-.901.018-1.358.044C129.31 3.407 123.644.779 118.75.779c-37.465 0-55.364 46.835-60.976 70.635-14.558 4.511-24.9 7.718-26.221 8.133-8.126 2.549-8.383 2.805-9.45 10.462C21.3 95.806.038 260.235.038 260.235l165.678 31.042 89.77-19.42S223.973 58.8 223.775 57.34zM156.49 40.848l-14.019 4.339c.005-.988.01-1.96.01-3.023 0-9.264-1.286-16.723-3.349-22.636 8.287 1.04 13.806 10.469 17.358 21.32zm-27.638-19.483c2.304 5.773 3.802 14.058 3.802 25.238 0 .572-.005 1.095-.01 1.624-9.117 2.824-19.024 5.89-28.953 8.966 5.575-21.516 16.025-31.908 25.161-35.828zm-11.131-10.537c1.617 0 3.246.549 4.805 1.622-12.007 5.65-24.877 19.88-30.312 48.297l-22.886 7.088C75.694 46.16 90.81 10.828 117.72 10.828z"
                          fill="#95BF46"
                        ></path>
                        <path
                          d="M221.237 54.983c-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-.637-.634-1.496-.959-2.394-1.099l-12.527 256.233 89.762-19.418S223.972 58.8 223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357"
                          fill="#5E8E3E"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  <span className="title">Shopify Free Section</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
